const snack = require('../../../../../components/snack/snack')
const textfieldHandler = require('../../../../../components/textfield/textfield-handler')
const retailChanges = require('./retail-dt-handler')

// Actualiza en el formulario la disponibilidad devuelta por la validacion backend.
export function updateInventoryAvailability(result, htmlFc) {
      const inventoryItems = result?.extrainfo?.items

      if (!htmlFc?.fullcontHTML || !Array.isArray(inventoryItems)) { return }

      const availabilityByPurchaseItem = new Map(
            inventoryItems.map((item) => [
                  String(item.purchase_vs_itemId),
                  toNumber(item.available_qty),
            ]),
      )

      const itemFields = htmlFc.fullcontHTML.querySelectorAll(
            '#retail_form_sale_vs_item .line .purchase_vs_itemId',
      )

      itemFields.forEach((itemField) => {
            const purchaseItemId = getSelectedId(itemField)

            if (!availabilityByPurchaseItem.has(purchaseItemId)) { return }

            const otherFieldElement = itemField.querySelector('.otherField')
            const otherField = getOtherField(otherFieldElement)

            if (otherFieldElement === null || otherField === null) { return }

            const availableQty = availabilityByPurchaseItem.get(purchaseItemId)
            otherField.qty_available = availableQty
            otherFieldElement.setAttribute('otherField', JSON.stringify(otherField))
            updateItemChipAvailability(itemField, availableQty)
      })

      validateInventoryQuantities(htmlFc)
}

export function otherFieldItem(detail, htmlFc) {
      const autocompleteLine = htmlFc.fullcontHTML.querySelector('#retail_form_item_mt_' + detail.id_ac)
      const rawFields = autocompleteLine.querySelector('.otherField').getAttribute('otherField')
      const item = JSON.parse(rawFields)
      const line = autocompleteLine.closest('.line')

      line.querySelector('.selling_type input').value = item.type
      line.querySelector('.cost input').value = toMoney(item.item_unit_cost)
      line.querySelector('.cogs_row_amount input').value = toMoney(item.cogs_row_amount)
      line.querySelector('.price input').value = toMoney(item.selling_price)
      line.querySelector('.qty input').value = ''
      line.querySelector('.total input').value = ''
      line.querySelector('.qty input').focus()
}

export function calculateValues(detail, htmlFc) {
      const autocompleteLine = htmlFc.fullcontHTML.querySelector('#retail_form_item_mt_' + detail.id_item_ac)
      const line = autocompleteLine.closest('.line')
      const qtyInput = line.querySelector('.qty input')
      const priceInput = line.querySelector('.price input')
      const totalInput = line.querySelector('.total input')
      normalizeIntegerQty(qtyInput)
      const qty = toNumber(qtyInput.value)
      const total = toNumber(totalInput.value)
      const taxPercentage = getTaxPercentage(htmlFc)
      const item = JSON.parse(autocompleteLine.querySelector('.otherField').getAttribute('otherField'))

      if (detail.input === 'total' && qty > 0 && totalInput.value !== '') {
            const taxFactor = 1 + (taxPercentage / 100)
            priceInput.value = (total / qty / taxFactor).toFixed(2)
      }

      if (qty > 0 && priceInput.value !== '') {
            updateLineTaxAmounts(line, qty, toNumber(priceInput.value), taxPercentage)
      }

      if (qty > toNumber(item.qty_available)) {
            snack.start({ act: 'show', id: 'insufficientQuantity' })
            textfieldHandler.error(qtyInput.closest('.textfield'))
      } else {
            textfieldHandler.errorClean(qtyInput.closest('.textfield'))
      }

      calculateGrandTotal(htmlFc)
}

function getTaxPercentage(htmlFc) {
      return Math.max(
            0,
            Math.min(100, toNumber(htmlFc.fullcontHTML.dataset.retailTaxPercentage || '0')),
      )
}

function updateLineTaxAmounts(line, qty, price, taxPercentage) {
      const subtotal = roundMoney(qty * price)
      const taxAmount = roundMoney(subtotal * (taxPercentage / 100))
      const total = roundMoney(subtotal + taxAmount)
      const totalInput = line.querySelector('.total input')

      if (totalInput) { totalInput.value = total.toFixed(2) }
}

function roundMoney(value) {
      return Math.round((toNumber(value) + Number.EPSILON) * 100) / 100
}

function normalizeIntegerQty(input) {
      if (input.value === '') { return }

      const qty = Number(input.value)
      input.value = Number.isInteger(qty) && qty >= 0 ? String(qty) : ''
}

function validateInventoryQuantities(htmlFc) {
      const lines = htmlFc.fullcontHTML.querySelectorAll('#retail_form_sale_vs_item .line')
      const itemGroups = new Map()

      lines.forEach((line) => {
            const itemField = line.querySelector('.purchase_vs_itemId')
            const purchaseItemId = getSelectedId(itemField)
            const otherField = getOtherField(itemField?.querySelector('.otherField'))
            const qtyField = line.querySelector('.qty')

            if (!purchaseItemId || otherField === null || qtyField === null) { return }

            if (!itemGroups.has(purchaseItemId)) {
                  itemGroups.set(purchaseItemId, {
                        availableQty: toNumber(otherField.qty_available),
                        requestedQty: 0,
                        qtyFields: [],
                  })
            }

            const group = itemGroups.get(purchaseItemId)
            group.requestedQty += toNumber(qtyField.querySelector('input')?.value)
            group.qtyFields.push(qtyField)
      })

      itemGroups.forEach((group) => {
            const hasInventoryError = group.requestedQty > group.availableQty

            group.qtyFields.forEach((qtyField) => {
                  if (hasInventoryError) {
                        textfieldHandler.error(qtyField.closest('.textfield'))
                  } else {
                        textfieldHandler.errorClean(qtyField.closest('.textfield'))
                  }
            })

            if (hasInventoryError) {
                  snack.start({ act: 'show', id: 'insufficientQuantity' })
            }
      })
}

function updateItemChipAvailability(itemField, availableQty) {
      const chip = itemField.querySelector('.chip-cont .chip')
      const chipLabel = chip?.querySelector('label')

      if (!chipLabel) { return }

      const displayParts = chipLabel.textContent.split(' - ')
      if (displayParts.length < 2) { return }

      if (displayParts.length >= 6) {
            // El autocomplete muestra la disponibilidad antes de la fecha.
            displayParts[displayParts.length - 2] = String(availableQty)
      } else if (chip.getAttribute('data-retail-availability') === 'true') {
            displayParts[displayParts.length - 1] = String(availableQty)
      } else {
            // Las facturas cargadas muestran un texto compacto sin disponibilidad.
            displayParts.push(String(availableQty))
            chip.setAttribute('data-retail-availability', 'true')
      }

      const displayText = displayParts.join(' - ')
      chipLabel.textContent = displayText
      chip.setAttribute('title', displayText)
}

function getSelectedId(itemField) {
      if (!itemField) { return '' }

      try {
            const selected = JSON.parse(itemField.getAttribute('selected') || '[]')
            return String(selected[0] ?? '')
      } catch (error) {
            return ''
      }
}

function getOtherField(otherFieldElement) {
      if (!otherFieldElement) { return null }

      try {
            return JSON.parse(otherFieldElement.getAttribute('otherField') || '{}')
      } catch (error) {
            return null
      }
}

export function calculateGrandTotal(htmlFc) {
      const lines = htmlFc.fullcontHTML.querySelectorAll('#retail_form_sale_vs_item .line')
      const grandTotal = htmlFc.fullcontHTML.querySelector('#retail_form_grand_total input')
      let total = 0

      lines.forEach((line) => {
            total += toNumber(line.querySelector('.total input').value)
      })

      grandTotal.value = total.toFixed(2)
}

export function setTaxPercentage(htmlFc, value) {
      const percentage = Math.max(0, Math.min(100, toNumber(value)))
      htmlFc.fullcontHTML.dataset.retailTaxPercentage = percentage.toFixed(2)

      const taxPercentageInput = htmlFc.fullcontHTML.querySelector('#retail_form_tax_percentage input')
      if (taxPercentageInput) { taxPercentageInput.value = percentage.toFixed(2) }
}

export function applyTaxPercentageToItems(htmlFc, value) {
      setTaxPercentage(htmlFc, value)

      const lines = htmlFc.fullcontHTML.querySelectorAll('#retail_form_sale_vs_item .line')
      lines.forEach((line) => {
            const qtyInput = line.querySelector('.qty input')
            const priceInput = line.querySelector('.price input')

            if (qtyInput?.value !== '' && priceInput?.value !== '') {
                  updateLineTaxAmounts(
                        line,
                        toNumber(qtyInput.value),
                        toNumber(priceInput.value),
                        getTaxPercentage(htmlFc),
                  )
            }
      })

      calculateGrandTotal(htmlFc)
}

export function pdfMenudt(detail) {
      if (!detail.dbid) { return }

      const formData = new FormData()
      formData.append('id', detail.dbid)
      formData.append('type', 'print')
      formData.append('entity', 'retail')
      formData.append('reportName', 'retail-invoice')

      fetch('./server/php/report/report-pdf.php', {
            method: 'POST',
            body: formData,
            credentials: 'same-origin',
      })
            .then((response) => {
                  const contentType = response.headers.get('content-type') || ''

                  if (!response.ok || !contentType.includes('application/pdf')) {
                        throw new Error('report-pdf')
                  }
                  return response.blob()
            })
            .then((blob) => {
                  return printRetailPdf(blob)
            })
            .catch(() => {
                  snack.start({ act: 'show', id: 'downloadError' })
            })
}

// Carga el PDF de Retail en el iframe global del framework y solicita su impresion.
function printRetailPdf(blob) {
      return new Promise((resolve, reject) => {
            const printFrame = document.getElementById('reportIframe')

            if (printFrame === null) {
                  reject(new Error('retail-print-frame'))
                  return
            }

            const previousUrl = printFrame.dataset.retailPdfUrl
            const fileUrl = URL.createObjectURL(new Blob([blob], { type: 'application/pdf' }))

            printFrame.dataset.retailPdfUrl = fileUrl
            printFrame.onload = null
            printFrame.src = fileUrl

            // El visor PDF de Chrome no siempre dispara load en un iframe oculto.
            // Se espera desde que se asigna el archivo, igual que en los reportes del framework.
            setTimeout(() => {
                  if (!printFrame.isConnected || printFrame.src !== fileUrl) {
                        URL.revokeObjectURL(fileUrl)
                        reject(new Error('retail-print-frame'))
                        return
                  }

                  try {
                        const printWindow = printFrame.contentWindow
                        if (printWindow === null) { throw new Error('retail-print-window') }

                        printWindow.focus()
                        printWindow.print()
                        resolve()
                  } catch (error) {
                        URL.revokeObjectURL(fileUrl)
                        reject(error)
                  }
            }, 500)

            if (previousUrl) { URL.revokeObjectURL(previousUrl) }
      })
}

// Presenta en la pestaña Changes la auditoría recibida desde Retail.
export function renderChanges(result, htmlFc) {
      const changesContainer = htmlFc?.fullcontHTML?.querySelector('#retail-changes')

      if (!changesContainer) { return }

      changesContainer.innerHTML = ''

      const entityChanges = Array.isArray(result?.entitychanges) ? result.entitychanges : []
      const changes = Array.isArray(entityChanges[0]?.data) ? entityChanges[0].data : []

      if (changes.length === 0) { return }

      changesContainer.insertAdjacentHTML(
            'beforeend',
            retailChanges.organizeRowEntityChange(changes),
      )
}

// Evita conservar el historial de la factura anterior al abrir un Retail nuevo.
export function clearChanges(htmlFc) {
      const changesContainer = htmlFc?.fullcontHTML?.querySelector('#retail-changes')

      if (changesContainer) { changesContainer.innerHTML = '' }
}

function toNumber(value) {
      const number = Number.parseFloat(value)
      return Number.isFinite(number) ? number : 0
}

function toMoney(value) {
      return toNumber(value).toFixed(2)
}
